import * as React from 'react';
import {connect} from 'react-redux';

import type {FilterObject} from 'nutshell-core/types';

// @ts-expect-error
import * as dashboardActions from '../../../master-dashboard/dashboard-actions';
// @ts-expect-error
import {getContactsSchema} from '../../../master-dashboard/dashboard-selectors';

import type {NutshellState} from '../../../../store';

import {ListProviderContext} from '../../entity-lists/list-provider-context';

import * as actions from '../editions-actions';
import * as selectors from '../editions-selectors';

type OwnProps = {
    children: React.ReactNode;
};

type StateProps = {
    schema: any;
    count: number;
    isFirstLoad: boolean;
    isLoading: boolean;
    hasError: boolean;
    listItems: any[];
    isFilterDrawerOpen: boolean;
};

type DispatchProps = {
    fetchList: (arg1: FilterObject[], arg2: number, arg3: string[], sort: string, q: string) => any;
    fetchContactsSchema: () => void;
    toggleShowFilterDrawer: () => void;
};

type Props = OwnProps & StateProps & DispatchProps;

function mapStateToProps(state: NutshellState): StateProps {
    return {
        schema: getContactsSchema(state),
        isFirstLoad: selectors.getEditionRecipientListIsFirstLoad(state),
        isLoading: selectors.getEditionRecipientListIsLoading(state),
        hasError: selectors.getEditionRecipientListHasError(state),
        listItems: selectors.getEditionRecipientListItems(state),
        count: selectors.getEditionRecipientListCount(state),
        isFilterDrawerOpen: selectors.getIsFilterDrawerOpen(state),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        fetchContactsSchema: () => {
            dispatch(dashboardActions.fetchContactsSchema());
        },
        fetchList: (
            filters: FilterObject[],
            pageNum: number,
            columns: string[],
            sort: string,
            q: string
        ) => {
            dispatch(actions.requestEditionRecipientListData({filters, pageNum, columns, sort, q}));
        },
        toggleShowFilterDrawer: () => {
            dispatch(actions.toggleShowFilterDrawer());
        },
    };
}

class EditionRecipientListProviderComponent extends React.Component<Props> {
    render() {
        const {
            schema,
            isFirstLoad,
            isLoading,
            hasError,
            listItems,
            count,
            isFilterDrawerOpen,
            fetchContactsSchema,
            fetchList,
            toggleShowFilterDrawer,
        } = this.props;

        return (
            <ListProviderContext.Provider
                // @ts-expect-error
                value={{
                    schema,
                    isFirstLoad,
                    isLoading,
                    hasError,
                    listItems,
                    count,
                    isFilterDrawerOpen,
                    fetchContactsSchema,
                    fetchList,
                    toggleShowFilterDrawer,
                }}
            >
                {this.props.children}
            </ListProviderContext.Provider>
        );
    }
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);
export const EditionRecipientListProvider = connector(EditionRecipientListProviderComponent);
